import { TABLE_ACTIVITY_GROUP_SETTINGS } from '../../../db/types'
import { db } from '../../../db'
import { useGetQuery } from '../../../db/hooks'
import { ActivityGroupSettings } from '../types'

export function deleteActivityGroupSettingItem(id: string, userId: string) {
  return db.table(TABLE_ACTIVITY_GROUP_SETTINGS).delete([id, userId])
}

export async function updateActivityGroupSettings(
  id: string,
  userId: string,
  assignedUserId: string
) {
  const oldItem = await getActivityGroupSettingItem(id, userId)

  if (oldItem) {
    await db.table(TABLE_ACTIVITY_GROUP_SETTINGS).delete([id, userId])
  }

  return db
    .table(TABLE_ACTIVITY_GROUP_SETTINGS)
    .add({ id: id, userId, assignedUserId: assignedUserId })
}

export function getActivityGroupSettingItem(id: string, userId: string) {
  return db.table(TABLE_ACTIVITY_GROUP_SETTINGS).get([id, userId])
}

export const useGetActivityGroupSettings = (userId: string | null) => {
  return useGetQuery<ActivityGroupSettings[] | null>(() => {
    if (userId === null) {
      return Promise.resolve(null)
    }

    return db
      .table(TABLE_ACTIVITY_GROUP_SETTINGS)
      .where('userId')
      .equals(userId)
      .toArray()
  }, [userId])
}
